const plans = [
  {
    name: 'Plano Free',
    price: 'Gratuito',
    period: '',
    description: 'Ideal para começar sua operação',
    features: [
      'Até 15 clientes/mês',
      'Contrato/Procuração Automático (até 15/mês)',
      'Upload de Documentos (até 15/mês)',
      'Recursos por IA - R$ 99,00/unidade',
      'Rastreamento - R$ 49/mês ou R$ 499/ano',
      'Plano Recorrente* - R$ 499/ano',
      'Editais - R$ 1,50/contato',
      'Mídia Social - R$ 80/lote (80 posts)',
    ],
    highlighted: false,
  },
  {
    name: 'Plano Intermediário',
    price: 'R$ 399',
    period: '/mês',
    description: 'Para operações em crescimento',
    features: [
      'Clientes ilimitados',
      'Contrato/Procuração ilimitado',
      'Upload de Documentos ilimitado',
      'Recursos por IA - R$ 49,00/unidade',
      'Rastreamento - R$ 35/mês ou R$ 350/ano',
      'Plano Recorrente* - R$ 400/ano',
      'Editais - R$ 1,20/contato',
      'Mídia Social - R$ 40 reais/lote (80 posts)',
    ],
    highlighted: true,
  },
  {
    name: 'Plano Top',
    price: 'R$ 999',
    period: '/mês',
    description: 'Solução completa para grandes operações',
    features: [
      'Clientes ilimitados',
      'Contrato/Procuração ilimitado',
      'Upload de Documentos ilimitado',
      '25 Recursos IA grátis + R$ 25/excedente',
      'Rastreamento - R$ 25/mês ou R$ 250/ano',
      'Plano Recorrente* - R$ 300/ano',
      'Editais - R$ 0,80/contato (prioritário)',
      'Mídia Social - Gratuito',
      'Marca, Material, Localização, Leads',
    ],
    highlighted: false,
  },
];

export default function PlansSection() {
  const scrollToContact = () => {
    const element = document.getElementById('contato');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="planos" className="py-12 md:py-24 bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 relative overflow-hidden">
      {/* Background Effects */}
      <div className="absolute top-0 left-1/4 w-48 md:w-96 h-48 md:h-96 bg-yellow-500/10 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 right-1/4 w-48 md:w-96 h-48 md:h-96 bg-amber-500/10 rounded-full blur-3xl"></div>
      
      {/* Dot Pattern */}
      <div className="absolute inset-0 opacity-10" style={{
        backgroundImage: 'radial-gradient(circle, #fbbf24 1px, transparent 1px)',
        backgroundSize: '30px 30px md:40px md:40px'
      }}></div>

      <div className="max-w-7xl mx-auto px-4 md:px-6 relative z-10">
        <div className="text-center mb-8 md:mb-16">
          <div className="inline-flex items-center gap-2 px-3 md:px-4 py-1.5 md:py-2 bg-yellow-500/20 rounded-full mb-4 md:mb-6 backdrop-blur-sm border border-yellow-500/30">
            <i className="ri-vip-crown-line text-yellow-400 text-sm md:text-base"></i>
            <span className="text-xs md:text-sm font-semibold text-yellow-400">Escolha seu Plano</span>
          </div>
          <h2 className="text-2xl md:text-5xl font-bold text-white mb-2 md:mb-4">Planos e Assinaturas</h2>
          <p className="text-sm md:text-xl text-gray-400 max-w-3xl mx-auto">
            Escolha o plano ideal para o seu negócio
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-8 mb-6 md:mb-8">
          {plans.map((plan, index) => (
            <div
              key={index}
              className={`relative rounded-2xl md:rounded-3xl p-5 md:p-8 transition-all duration-500 group ${
                plan.highlighted
                  ? 'bg-gradient-to-br from-yellow-500 via-amber-500 to-orange-500 text-white shadow-2xl shadow-yellow-500/30 md:transform md:scale-105 z-10'
                  : 'bg-gradient-to-br from-gray-800/80 via-gray-800/60 to-gray-900/80 text-white hover:shadow-xl hover:shadow-yellow-500/10 border border-gray-700/50 backdrop-blur-sm hover:border-yellow-500/30'
              }`}
            >
              {/* Shine Effect */}
              <div className={`absolute inset-0 rounded-2xl md:rounded-3xl overflow-hidden pointer-events-none ${plan.highlighted ? 'opacity-100' : 'opacity-0 group-hover:opacity-100'} transition-opacity duration-500`}>
                <div className="absolute inset-0 bg-gradient-to-tr from-transparent via-white/10 to-transparent"></div>
                <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-white/50 to-transparent"></div>
              </div>

              {plan.highlighted && (
                <div className="inline-block px-3 md:px-4 py-1 bg-white/20 rounded-full text-xs md:text-sm font-semibold mb-3 md:mb-4 backdrop-blur-sm border border-white/30">
                  <i className="ri-star-fill mr-1"></i>
                  Mais Popular
                </div>
              )}
              <h3 className="text-lg md:text-2xl font-bold mb-1 md:mb-2 relative z-10">{plan.name}</h3>
              <p className={`text-xs md:text-sm mb-4 md:mb-6 relative z-10 ${plan.highlighted ? 'text-white/90' : 'text-gray-400'}`}>
                {plan.description}
              </p>
              <div className="mb-4 md:mb-8 relative z-10">
                <span className={`text-3xl md:text-5xl font-bold ${plan.highlighted ? 'text-white' : 'bg-gradient-to-r from-white to-gray-300 bg-clip-text text-transparent'}`}>{plan.price}</span>
                <span className={`text-sm md:text-lg ${plan.highlighted ? 'text-white/80' : 'text-gray-400'}`}>{plan.period}</span>
              </div>
              <ul className="space-y-2 md:space-y-4 mb-6 md:mb-8 relative z-10">
                {plan.features.map((feature, idx) => {
                  const isRecorrente = feature.includes('Plano Recorrente');
                  return (
                    <li 
                      key={idx} 
                      className={`flex items-start gap-2 md:gap-3 ${
                        isRecorrente 
                          ? plan.highlighted
                            ? 'bg-white/20 -mx-2 px-2 py-1.5 rounded-lg border border-white/30'
                            : 'bg-gradient-to-r from-yellow-500/20 to-amber-500/20 -mx-2 px-2 py-1.5 rounded-lg border border-yellow-500/40'
                          : ''
                      }`}
                    >
                      <div className={`w-4 md:w-5 h-4 md:h-5 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5 ${
                        plan.highlighted ? 'bg-white/20' : 'bg-yellow-500/20'
                      }`}>
                        <i
                          className={`ri-check-line text-[10px] md:text-sm ${
                            plan.highlighted ? 'text-white' : 'text-yellow-400'
                          }`}
                        ></i>
                      </div>
                      <span className={`text-xs md:text-sm ${
                        isRecorrente
                          ? plan.highlighted
                            ? 'text-white font-semibold'
                            : 'text-yellow-300 font-semibold'
                          : plan.highlighted 
                            ? 'text-white/90' 
                            : 'text-gray-300'
                      }`}>
                        {feature}
                      </span>
                    </li>
                  );
                })}
              </ul>
              <a
                href="https://app.centraldamulta.app.br/register"
                target="_blank"
                rel="noopener noreferrer"
                className={`block w-full py-3 md:py-4 rounded-full font-semibold transition-all whitespace-nowrap cursor-pointer relative overflow-hidden group/btn text-sm md:text-base text-center ${
                  plan.highlighted
                    ? 'bg-white text-gray-900 hover:bg-gray-100 shadow-lg'
                    : 'bg-gradient-to-r from-yellow-500 to-amber-500 text-gray-900 hover:from-yellow-400 hover:to-amber-400 shadow-lg shadow-yellow-500/20'
                }`}
              >
                <span className="relative z-10">Cadastre-se Grátis</span>
                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/30 to-transparent -translate-x-full group-hover/btn:translate-x-full transition-transform duration-700"></div>
              </a>
            </div>
          ))}
        </div>

        {/* Detalhes do Plano Recorrente */}
        <div className="bg-gradient-to-br from-gray-800/80 via-gray-800/60 to-gray-900/80 rounded-2xl md:rounded-3xl p-5 md:p-12 mb-10 md:mb-20 border border-yellow-500/30 backdrop-blur-sm relative overflow-hidden">
          {/* Shine Effect */}
          <div className="absolute inset-0 bg-gradient-to-tr from-transparent via-yellow-500/5 to-transparent pointer-events-none"></div>
          <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-yellow-500/50 to-transparent"></div>
          
          <div className="flex flex-col md:flex-row items-start gap-4 md:gap-6 relative z-10">
            <div className="w-12 md:w-16 h-12 md:h-16 bg-gradient-to-br from-yellow-400 via-yellow-500 to-amber-600 rounded-xl md:rounded-2xl flex items-center justify-center flex-shrink-0 shadow-lg shadow-yellow-500/40 relative overflow-hidden">
              <div className="absolute inset-0 bg-gradient-to-tr from-transparent via-white/30 to-transparent"></div>
              <i className="ri-repeat-line text-gray-900 text-xl md:text-3xl relative z-10"></i>
            </div>
            <div className="flex-1">
              <h3 className="text-xl md:text-3xl font-bold text-white mb-3 md:mb-4">
                Como Funciona o Plano Recorrente?
              </h3>
              <p className="text-sm md:text-lg text-gray-300 mb-4 md:mb-6 leading-relaxed">
                O <strong className="text-yellow-400">Plano Recorrente</strong> é divulgado em nosso site para clientes do Brasil todo, uma oferta irresistível para fomentar a geração de novos negócios para nossos parceiros.
              </p>
              
              <div className="space-y-3 md:space-y-4">
                <div className="flex items-start gap-3 md:gap-4 group">
                  <div className="w-6 md:w-8 h-6 md:h-8 bg-gradient-to-br from-yellow-400 to-amber-500 rounded-full flex items-center justify-center flex-shrink-0 shadow-lg shadow-yellow-500/30 group-hover:scale-110 transition-transform">
                    <span className="text-gray-900 font-bold text-xs md:text-sm">1</span>
                  </div>
                  <div className="bg-gray-800/50 rounded-xl md:rounded-2xl p-3 md:p-4 flex-1 border border-gray-700/50 group-hover:border-yellow-500/30 transition-colors">
                    <h4 className="font-semibold text-white text-sm md:text-base mb-1">Primeiro Recurso</h4>
                    <p className="text-xs md:text-base text-gray-400">
                      Você cobra o primeiro recurso de acordo com sua tabela de preços.
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-3 md:gap-4 group">
                  <div className="w-6 md:w-8 h-6 md:h-8 bg-gradient-to-br from-yellow-400 to-amber-500 rounded-full flex items-center justify-center flex-shrink-0 shadow-lg shadow-yellow-500/30 group-hover:scale-110 transition-transform">
                    <span className="text-gray-900 font-bold text-xs md:text-sm">2</span>
                  </div>
                  <div className="bg-gray-800/50 rounded-xl md:rounded-2xl p-3 md:p-4 flex-1 border border-gray-700/50 group-hover:border-yellow-500/30 transition-colors">
                    <h4 className="font-semibold text-white text-sm md:text-base mb-1">Rastreamento e recursos por 12 Meses</h4>
                    <p className="text-xs md:text-base text-gray-400 mb-2">
                      Após o primeiro recurso, ofereça ao cliente:
                    </p>
                    <ul className="space-y-1 md:space-y-2">
                      <li className="flex items-center gap-2">
                        <div className="w-5 md:w-6 h-5 md:h-6 bg-yellow-500/20 rounded-full flex items-center justify-center">
                          <i className="ri-star-fill text-yellow-400 text-[10px] md:text-xs"></i>
                        </div>
                        <span className="text-xs md:text-sm text-gray-300"><strong className="text-yellow-400">Recursos GRATUITOS</strong> por 12 meses OU</span>
                      </li>
                      <li className="flex items-center gap-2">
                        <div className="w-5 md:w-6 h-5 md:h-6 bg-amber-500/20 rounded-full flex items-center justify-center">
                          <i className="ri-price-tag-3-fill text-amber-400 text-[10px] md:text-xs"></i>
                        </div>
                        <span className="text-xs md:text-sm text-gray-300"><strong className="text-amber-400">Valor reduzido</strong> por recurso extra (Exemplo: R$ 100,00 por recurso extra)</span>
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="flex items-start gap-3 md:gap-4 group">
                  <div className="w-6 md:w-8 h-6 md:h-8 bg-gradient-to-br from-yellow-400 to-amber-500 rounded-full flex items-center justify-center flex-shrink-0 shadow-lg shadow-yellow-500/30 group-hover:scale-110 transition-transform">
                    <span className="text-gray-900 font-bold text-xs md:text-sm">3</span>
                  </div>
                  <div className="bg-gray-800/50 rounded-xl md:rounded-2xl p-3 md:p-4 flex-1 border border-gray-700/50 group-hover:border-yellow-500/30 transition-colors">
                    <h4 className="font-semibold text-white text-sm md:text-base mb-1">Vantagem Competitiva</h4>
                    <p className="text-xs md:text-base text-gray-400">
                      Oferta única no Brasil. Fidelize clientes e garanta receitas previsíveis por 12 meses.
                    </p>
                  </div>
                </div>
              </div>

              <div className="mt-4 md:mt-6 p-3 md:p-4 bg-gradient-to-r from-yellow-500/10 to-amber-500/10 rounded-lg md:rounded-xl border border-yellow-500/30">
                <p className="text-xs md:text-sm text-gray-300">
                  <i className="ri-lightbulb-flash-line text-yellow-400 mr-2"></i>
                  <strong className="text-yellow-400">Dica:</strong> Use o Plano Recorrente como argumento de venda para fechar contratos anuais!
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
